import NextPaymentDetails from "interfaces/response/NextPaymentDetails";
import Product from "interfaces/response/Product";
import { NextPaymentDetailsType } from "shared/enums/NextPaymentDetailsTypeEnum";
import { SubscriptionPaymentStatus } from "shared/enums/SubscriptionPaymentStatusEnum";
import { SubscriptionScheduledOperationType } from "shared/enums/SubscriptionScheduledOperationTypeEnum";
import { RootState } from "store/store";
import { checkIfDateIsAfterTodayFromString } from "./DateTimeUtility";

export const getSelectedProductId = (state: RootState) => {
  return state.productData.selectedProductId;
};

export const getCurrentSelectedProduct = (state: RootState) => {
  return state.productData.productWithLicenseInfo as Product;
};

export const getSelectedProductSubscriptionId = (state: RootState) => {
  return state.subscriptionData.selectedProductSubscriptionId;
};

export const getCurrentProductLicenses = (state: RootState) => {
  const products = getCurrentSelectedProduct(state);
  const availablePlans = products?.productLicenses || [];
  return availablePlans;
};

export const getCurrentProductSubscriptionDetail = (state: RootState) => {
  return state.subscriptionData.selectedProductSubscription;
};

export const getCurrentSubscriptionPlanLicense = (state: RootState) => {
  const subscription = getCurrentProductSubscriptionDetail(state);

  if (subscription) {
    const productLicenses = getCurrentProductLicenses(state);
    const selectedProductLicense = productLicenses.find(
      (pl) => pl.id === subscription.productLicenseId
    );

    return selectedProductLicense;
  }

  return null;
};

export const getDefaultFreeLiceneOfSelectedProduct = (state: RootState) => {
  const productLicenses = getCurrentProductLicenses(state);
  const defaultFreeLiceneOfSelectedProduct = productLicenses.find(
    (license) => license.isDefaultFreeLocalLicense === true
  );

  return defaultFreeLiceneOfSelectedProduct;
};

export const getNextPaymentDetails = (state: RootState) => {
  const currentSubscription = getCurrentProductSubscriptionDetail(state);
  const currentSubscriptionLicense = getCurrentSubscriptionPlanLicense(state);
  let nextPaymentDetails: NextPaymentDetails = {
    type: -1,
    date: "",
  };

  if (currentSubscription) {
    if (currentSubscriptionLicense?.isDefaultFreeLocalLicense) {
      nextPaymentDetails.type = NextPaymentDetailsType.Free;
    } else {
      if (
        currentSubscription.paymentStatus === SubscriptionPaymentStatus.Active
      ) {
        if (currentSubscription.subscriptionScheduledOperations.length === 0) {
          if (currentSubscription.currentPeriodFinish) {
            // Current subscription is active and is not default free license and has no scheduled operation
            nextPaymentDetails.type = NextPaymentDetailsType.Active;
            nextPaymentDetails.date = currentSubscription.currentPeriodFinish;
          }
        } else {
          // Current subscription is active and has scheduled operation
          if (
            currentSubscription.subscriptionScheduledOperations[0].type ===
            SubscriptionScheduledOperationType.Downgrade
          ) {
            nextPaymentDetails.type = NextPaymentDetailsType.Downgrade;
          }

          nextPaymentDetails.date =
            currentSubscription.subscriptionScheduledOperations[0].scheduledOn;
        }
      } else {
        if (
          currentSubscription.isInGracePeriod &&
          currentSubscription.gracePeriodFinish &&
          checkIfDateIsAfterTodayFromString(
            currentSubscription.gracePeriodFinish
          )
        ) {
          // Current subscription is in grace period
          nextPaymentDetails.type = NextPaymentDetailsType.GracePeriod;
          nextPaymentDetails.date = currentSubscription.gracePeriodFinish;
        } else {
          // Payment overdue for current subscription
          nextPaymentDetails.type = NextPaymentDetailsType.PaymentDue;
        }
      }
    }
  }

  return nextPaymentDetails;
};
